import { useTranslation } from "Shared/util/custom-hooks";
import makeComponentTrashable from "trashable-react";
import InputCheckbox from "Shared/components/input-checkbox";
import { funcFilterStatus } from "Shared/util/translations";
import styles from "./export-transactions-options-subtitles.css";

const groupExportOptions = (options) => {
    const grouped = {};
    for (const key in options) {
        const { group = "" } = options[key];
        grouped[group] ??= [];
        grouped[group].push({ key, ...options[key] });
    }
    return grouped;
};

const ExportTransactionsOptionsSubtitles = ({
    enabledExportOptions,
    selectedExportOption,
    setSelectedExportOption,
    handleExportOptionClick,
}) => {
    const t = useTranslation((x) => x.export);
    const tg = useTranslation((x) => x.export.subtitles);

    const isExportOptionChecked = (option) =>
        selectedExportOption.description === option.description;

    const groups = groupExportOptions(enabledExportOptions);

    return (
        <div className={styles.formatOptionsContainer}>
            {Object.entries(groups).map(([groupName, options]) => (
                <div key={groupName} className={styles.optionsSubtitlesContainer}>
                    <h4 className={styles.subtitle}>{tg.findByKey(groupName)}</h4>
                    <div className={styles.formatOptions}>
                        {Object.keys(options).map((option) => (
                            <div
                                key={option}
                                className={styles.formatOption}
                                onClick={() => setSelectedExportOption(options[option])}
                            >
                                <InputCheckbox
                                    checked={isExportOptionChecked(options[option])}
                                    onChange={() => handleExportOptionClick(options[option])}
                                    className={styles.customCheckbox}
                                />
                                <div className={styles.formatOptionText}>
                                    <div className={styles.formatOptionTitle}>{funcFilterStatus(options[option], t, 'title').title}</div>
                                    <div className={styles.formatOptionDescription}>{options[option].description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default makeComponentTrashable(ExportTransactionsOptionsSubtitles);